// removed by extract-text-webpack-plugin
module.exports = {"page":"_2Zws","app":"_2ABs"};


//////////////////
// WEBPACK FOOTER
// ./~/@pickle/pickle-shared/src/components/Page/Page.scss
// module id = Zq1M
// module chunks = 0